import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const RelatoriosController = {
  async ListRelatorios() {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `monitoring/results_daily_panel`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },
  async ListRelatoriosConsolidate(startDate, endDate) {
    try {
      const response = await axios.get(`${AppConfig.BACKEND_URL}/resultado_fichas_relatorio_consolidado`, {
        params: {
          start_date: startDate,
          end_date: endDate
        },
        headers: {
          Authorization: `Bearer ${jwtToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },
  async ListResultRelatorios(audit_name, audit_id) {
    try {
      const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}monitoring/results_daily_report`, {
        params: {
          audit_name: audit_name,
          audit_id: audit_id,
        },
        headers: {
          Authorization: `Bearer ${jwtToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching transcripts:", error);
      throw error;
    }
  },
  async ListResultsQuestions(audit_id, date_start, date_end) {
    return axios
      .post(AppConfig.BACKEND_URL_REFATORADO + `relatorios_page/get_questions_extraction`,
        {
          audit_id: audit_id,
          date_start: date_start,
          date_end: date_end
        }, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  },
};

export default RelatoriosController;
